export default {
    accept: 'Принять',
    reject: 'Отклонить',
};
